import WidgetClassListModelBase from '../_generated/modelBases/widget-class-list-model-base';

export default class WidgetClassListModel extends WidgetClassListModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
